module.exports = require('./rest.json');
